import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { loadFeaturedStorefrontProducts } from "../data/storefront";
import { addProductToCart, getSuggestedCartAmount } from "../data/cart";

const ProductItem = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchProducts = async () => {
      const loadedProducts = await loadFeaturedStorefrontProducts(10);
      if (isMounted) {
        setProducts(loadedProducts);
      }
    };

    fetchProducts();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleAddClick = async (product) => {
    try {
      await addProductToCart(product, getSuggestedCartAmount(product));
      await Swal.fire({
        icon: "success",
        title: "Ajoute au panier",
        text: "Produit reserve et ajoute au panier.",
        showConfirmButton: true,
        timer: 2200,
      });
      navigate("/ShopCart");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Stock indisponible",
        text: error.message,
      });
    }
  };

  return (
    <div>
      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-6">
              <div className="section-head text-center mt-8">
                <h3 className="h3style" data-title="Produits populaires">Produits populaires</h3>
                <div className="wt-separator bg-primarys"></div>
                <div className="wt-separator2 bg-primarys"></div>
              </div>
            </div>
          </div>
          <div className="row g-4 row-cols-lg-5 row-cols-2 row-cols-md-3">
            {products.map((product) => (
              <div className="col fade-zoom" key={product.id}>
                <div className="card card-product">
                  <div className="card-body">
                    <div className="text-center position-relative ">
                      <div className=" position-absolute top-0 start-0">
                        <span className="badge bg-danger">{product.badge}</span>
                      </div>
                      <Link to="/SingleShop">
                        <img src={product.image} alt={product.name} className="mb-3 img-fluid " />
                      </Link>
                    </div>
                    <div className="text-small mb-1">
                      <Link to="/Shop" className="text-decoration-none text-muted"><small>{product.category}</small></Link>
                    </div>
                    <h2 className="fs-6">
                      <Link to="/SingleShop" className="text-inherit text-decoration-none">{product.name}</Link>
                    </h2>
                    {product.maxPerOrder ? (
                      <div className="small text-muted mb-1">
                        <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle">
                          Max {product.maxPerOrder} par commande
                        </span>
                      </div>
                    ) : null}
                    <div>
                      <small className="text-warning">
                        <i className="bi bi-star-fill" />
                        <i className="bi bi-star-fill" />
                        <i className="bi bi-star-fill" />
                        <i className="bi bi-star-fill" />
                        <i className="bi bi-star-half" />
                      </small>{" "}
                      <span className="text-muted small">{product.rating} ({product.reviews})</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        <span className="text-dark">{product.priceLabel}</span>
                        {product.unitLabel ? <div className="small text-muted">{product.unitLabel}</div> : null}
                      </div>
                      <div>
                        <button type="button" className="btn btn-primary btn-sm" onClick={() => handleAddClick(product)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus">
                            <line x1={12} y1={5} x2={12} y2={19} />
                            <line x1={5} y1={12} x2={19} y2={12} />
                          </svg>{" "}
                          Ajouter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductItem;
